import { RequestHeaders } from '@/constants/requestHeaders';
import { useConfigStore } from '@/stores/configStore';
import type { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

export const applyApiUrlInterceptor = (axios: AxiosInstance) => {
  const { apiRoot, reportingRoot } = useConfigStore();
  axios.interceptors.request.use(
    (requestConfig: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
      if (requestConfig.headers.get(RequestHeaders.UseReportingUrl)) {
        requestConfig.baseURL = reportingRoot;
        requestConfig.headers.delete(RequestHeaders.UseReportingUrl);
      } else {
        requestConfig.baseURL = apiRoot;
      }
      return requestConfig;
    }
  );
};
